import React from 'react'

const IconSaveDisk = (props) => {
  const width = props.width || props.size
  const height = props.height || props.size

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 26 26"
      fill={props.color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17 16.5C17 18.9853 14.9853 21 12.5 21C10.0147 21 8 18.9853 8 16.5C8 14.0147 10.0147 12 12.5 12C14.9853 12 17 14.0147 17 16.5ZM14.6 16.5C14.6 17.6598 13.6598 18.6 12.5 18.6C11.3402 18.6 10.4 17.6598 10.4 16.5C10.4 15.3402 11.3402 14.4 12.5 14.4C13.6598 14.4 14.6 15.3402 14.6 16.5Z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 25V1H18.4L25 7.6V25H1ZM22.6 22.6V8.59412L17.8 3.79412V10.6H5.8V3.4H3.4V22.6H22.6ZM8.2 3.4H15.4V8.2H8.2V3.4Z"
        fill={props.color}
      />
    </svg>
  )
}

IconSaveDisk.defaultProps = {
  color: 'currentcolor',
  size: '1em',
}

export default IconSaveDisk
